import { controllerQueries } from "../controllers/utils/utils";
import App from "../controllers/App/App";
import StructuredData from "../controllers/App/StructuredData";
import { hasModule } from "../utils/utils";

const StructuredDataController = (props) => {
    const { modules } = props;
    const modifiedProps = { ...props, hasHeroBanner: true }
    const Controller = hasModule(modules, "new_navigation") ? StructuredData : App;
    return <Controller {...modifiedProps} />;
};

StructuredDataController.queries = (args, userModulesByProject) => {
    return controllerQueries(args, userModulesByProject)
};

const queries = (args = {}) => {
    return args.projectId ? [
        {
            resource: "data_files_types_present",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
            body: "hasSource, hasLegal",
        }
    ] : [];
};

const structuredData = (path, navigation, exact, navByImportId = false) => ({
    path,
    navigation,
    component: StructuredDataController,
    queries,
    exact,
    navByImportId,
    title: "label(Structured Data)",
    hasSource: "query(0).hasSource",
    hasLegal: "query(0).hasLegal",
    components: []
});

export default structuredData;
